import moment from 'moment';

export function convertValueByType(
  value: string | number | boolean | Date | null,
  dataType: 'string' | 'number' | 'boolean' | 'Date' | 'DateTime',
): number | string | null {
  if (!value) return '';
  if (dataType === 'number') return Number(value);
  if (dataType === 'string') return value.toString();
  if (dataType === 'Date') return moment(value.toString()).format('DD.MM.Y');
  if (dataType === 'DateTime') return moment(value.toString()).format('DD.MM.Y HH:mm');

  return null;
}
